import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVendingMachine = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Regular",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "vending-machine" }),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-1",
			x: 3,
			y: .75,
			width: 18,
			height: 21,
			rx: 1.5,
			ry: 1.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 4.5,
			y1: 21.75,
			x2: 4.5,
			y2: 23.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 19.5,
			y1: 21.75,
			x2: 19.5,
			y2: 23.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 15,
			y1: .75,
			x2: 15,
			y2: 21.75
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-1",
			x: 6,
			y: 3.75,
			width: 6,
			height: 12
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 6,
			y1: 18.75,
			x2: 12,
			y2: 18.75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 18,
			y1: 3.75,
			x2: 18,
			y2: 5.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 18,
			y1: 8.25,
			x2: 18,
			y2: 9.75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 18,
			y1: 17.25,
			x2: 18,
			y2: 18.75
		})
	]
});
export default SvgVendingMachine;
